import { I18nextProvider } from 'react-i18next';
import i18n from '../src/i18n';
import './App.css';
import TopBar from './components/TopBar';
import Landing from './components/Landing';
import ClientOffice from './components/ClientOffice';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
    return (
    <div className='App'>
        <I18nextProvider i18n={i18n}>
            <Router>
                <div>
                    <TopBar />
                    <Routes>
                        <Route path='/' element={<Landing />} />
                        <Route path='client/*' element={<ClientOffice />} />
                    </Routes>
                </div>
            </Router>
        </I18nextProvider>
    </div>
    );
}

export default App;
